import React from "react";
import { getBetLifecycleStatus } from "../lib/betLifecycleStatus";

/**
 * Shows ticket lifecycle label + short detail for Active Bets and modals.
 */
export default function BetStatusBadge({ item, showDetail = true, className = "" }) {
  const { label, variant, detail, legsSummary } = getBetLifecycleStatus(item);

  return (
    <div className={`bet-status-wrap ${className}`.trim()}>
      <span className={`bet-status-badge bet-status-${variant}`} title={detail}>
        {label}
      </span>
      {showDetail && detail ? (
        <span className="bet-status-detail d-block mt-1">{detail}</span>
      ) : null}
      {showDetail && legsSummary ? (
        <span className="bet-status-legs d-block mt-1 text-muted small">
          {legsSummary}
        </span>
      ) : null}
    </div>
  );
}
